import { Box } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { ViewPosting } from './Components/ViewPosting'
import { EditPosting } from './Components/EditPosting'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useGetJobQuery } from '../../Redux/api/jobApi'
import { useGetClientQuery } from '../../Redux/api/clientApi'
import { skipToken } from '@reduxjs/toolkit/query'
import { JobPostingSkeleton } from './Components/JobPostingSkeleton'
import { useAppSelector } from '../../Redux/store'
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout'

export const JobPosting = () => {
const navigate = useNavigate();
const { locator, mode } = useParams();
const userId = useAppSelector( state => state.Global.userId)
const {data: job, isLoading: jobLoading, isFetching: jobFetching} = useGetJobQuery( locator || skipToken);
const {data: client, isLoading: clientLoading, isFetching: clientFetching} = useGetClientQuery(job?.client_locator || skipToken);
/* ******************** Variables ******************** */
const [_mode, setMode] = useState<'view' | 'edit'>('view');
/* ******************** Functions ******************** */
/* ******************** Effects ******************** */
useEffect(() =>{
    //@ts-ignore
    if ( mode === 'edit' && job?.client_locator === userId) setMode(mode)    
    if (!mode) setMode(_mode)
}, [job])
/* ******************** JSX ******************** */
    return (
        <KaziLayout>
            {
                jobLoading || clientLoading ?
                <JobPostingSkeleton /> :
                (_mode === 'view' ?
                <ViewPosting job={job!} client={client!} mode={_mode} setMode={setMode}/> :
                <EditPosting job={job!} client={client!} mode={_mode} setMode={setMode}/>)
            }
        </KaziLayout>
    )
}